import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { LocalityType } from '@domain-group/fe-allhomes-library';
import { AdSpot } from '@domain-group/fe-co-allhomes-ads';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import localityPropType from '../proptypes/locality';
import AllhomesSearchSurroundingSuburbs from './surrounding-suburbs/surrounding-suburbs';
import SuburbInfoLink from './allhomes-listing-suburb-info-link';
import OldPropertyAlertButton from './old-property-alert-button';
import AgentsLink from './allhomes-listing-agents-link';
import * as styles from './allhomes-listing-search-footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var researchPath = '/ah/research/';
var agentsPath = '/agents/results/';
var getSuburbInfoLink = (hostName, singleLocality) => {
  if (!singleLocality) {
    return '';
  }
  var suburbName = singleLocality.name;
  var suburbId = "".concat(singleLocality.id);

  // This should be handled by the URL-assembling Java code but we need a quick fix and these
  // research URLs should die soonish anyway.
  var sanitise = victim => victim.toLowerCase().trim().replace(/[\s_/,]/g, '-').replace(/[^a-z0-9-]/g, '').replace(/[-]{2,}/g, '-');
  return "".concat(hostName).concat(researchPath).concat(sanitise(suburbName), "/12").concat(suburbId, "10");
};
var getAgentsLink = (hostName, singleLocality) => {
  if (!singleLocality) {
    return '';
  }
  return "".concat(hostName).concat(agentsPath).concat(singleLocality.slug, "/");
};
var Footer = props => {
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var isMobile = props.media.mobile;
  var adSpot = isMobile ? {
    gpt: 'adspot-300x50-pos-1',
    adbridg: 'adb-ah-srp-bottom'
  } : {
    gpt: 'adspot-300x250-pos1',
    adbridg: 'adb-ah-srp-bottom'
  };
  var isBrowseDivision = props.singleLocality ? props.singleLocality.type === LocalityType.DIVISION.type : false;
  var suburbName = props.singleLocality ? props.singleLocality.name : '';
  return ___EmotionJSX("div", {
    css: styles.bottomContent
  }, ___EmotionJSX("div", {
    css: styles.adspotWrapper
  }, ___EmotionJSX(AdSpot, {
    gpt: {
      adId: adSpot.gpt,
      strategy: 'window.onload'
    },
    adbridg: {
      id: adSpot.adbridg
    }
  })), ___EmotionJSX("div", {
    css: styles.rightColumnWrapper
  }, ___EmotionJSX("div", {
    css: styles.suburbInfoWrapper({
      fullLength: isEmpty(props.surroundingSuburbs)
    })
  }, isBrowseDivision && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SuburbInfoLink, {
    linkUrl: getSuburbInfoLink(props.hostName, props.singleLocality),
    suburbName: suburbName,
    numberOfProperties: props.numberOfProperties,
    media: props.media
  }), ___EmotionJSX(AgentsLink, {
    linkUrl: getAgentsLink(props.hostName, props.singleLocality),
    suburbName: suburbName
  })), ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.propertyAlert
  }, "Get notified when new properties matching your search criteria are listed on Allhomes"), ___EmotionJSX(OldPropertyAlertButton, {
    buttonLabel: "Create email alert for this search",
    onPropertyAlertClick: props.onPropertyAlertClick,
    targetUrl: getAbsoluteUrl('/research')
  }))), isBrowseDivision && !isEmpty(props.surroundingSuburbs) && ___EmotionJSX("div", {
    css: styles.surroundingSuburbsWrapper
  }, ___EmotionJSX(AllhomesSearchSurroundingSuburbs, {
    name: suburbName,
    items: props.surroundingSuburbs,
    listingCategory: props.listingCategory
  }))));
};
Footer.propTypes = {
  singleLocality: localityPropType,
  numberOfProperties: PropTypes.number.isRequired,
  surroundingSuburbs: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string
  })),
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    desktop: PropTypes.bool,
    tablet: PropTypes.bool
  }),
  hostName: PropTypes.string.isRequired,
  onPropertyAlertClick: PropTypes.func,
  listingCategory: PropTypes.string
};
Footer.defaultProps = {
  singleLocality: null,
  surroundingSuburbs: [],
  media: {},
  onPropertyAlertClick: () => {},
  listingCategory: ''
};
export default Footer;